// extracted by mini-css-extract-plugin
export default {"notice":"companyImpersonationNotice_notice__JdcBm","dragging":"companyImpersonationNotice_dragging__o06F5","fixed-position":"companyImpersonationNotice_fixed-position__0qHwT"};